import { LogService } from 'service/log/logService';
import { ALGOLIA_SEARCH_INDEX_MAP, buildAlgoliaQuery } from '../builder/Builder';
import getSearchClient from '../client';
import { ISuggestedResult } from 'components/Cards/types';

const getAlgoliaData = async (
  indexName: string,
  query: string,
  filters: string,
  hitsPerPage = 150,
) => {
  const index = getSearchClient().initIndex(indexName);

  return index.search(query, {
    filters,
    hitsPerPage, // TODO: we shouldn't be getting 150 items please add lazy loading
    clickAnalytics: true,
  });
};

export const getAlgoliaExtensionData = async (
  data: any,
  hitsPerPage: number,
): Promise<ISuggestedResult | undefined> => {
  const { variation, extensionKey } = ALGOLIA_SEARCH_INDEX_MAP[data?.cardVariation || 'recipe'];
  const indexName = `${data?.extension?.environment}_${variation}_${data?.extension?.markets}${
    data?.extension?.topRated ? '_top_rated' : ''
  }`;

  const refinementList = data?.extension?.[extensionKey]?.refinementList || {};
  const filters = buildAlgoliaQuery(refinementList);
  return LogService.logDuration(
    'AlgoliaClient',
    'GetAlgoliaExtensionData',
    getAlgoliaData(indexName, data?.extension?.[extensionKey]?.query, filters, hitsPerPage),
  )
    .then((response: any) => ({
      hits: response.hits,
      queryID: response.queryID,
    }))
    .catch((error: any) => {
      // eslint-disable-next-line no-console
      console.error('Something went wrong with your search Query', error);
      return undefined;
    });
};
